import { RG_TYPE as e } from "@project-rouge/rg-core";
import { getVerticalWallArea as t } from "./index59.js";
const o = (r) => t(r, [e.EmptySpace]);
export {
  o as getCommercialWallArea
};
//# sourceMappingURL=index13.js.map
